export default function Modals () {
  const CONTACT_MODAL = new Modal('contact-modal', '.open-contact-modal, a[href="#open-contact-modal"]')
  CONTACT_MODAL.init()
}

class Modal {
  constructor (ELEMENT, SELECTOR) {
    this.ELEMENT = document.getElementById(ELEMENT)
    this.PARAM = '#wpcf7'
    this.OPEN_BUTTONS = document.querySelectorAll(SELECTOR)
    this.CLOSE_BUTTONS = this.ELEMENT.querySelectorAll('.mtt-modal__close, .mtt-modal__overlay')
  }

  init () {
    if (!this.ELEMENT) return

    // Open modal
    if (this.OPEN_BUTTONS.length > 0) {
      for (let i = 0; i < this.OPEN_BUTTONS.length; i++) {
        this.OPEN_BUTTONS[i].addEventListener('click', this.openModal.bind(this))
      }
    }

    // Close modal
    if (this.CLOSE_BUTTONS.length > 0) {
      for (let i = 0; i < this.CLOSE_BUTTONS.length; i++) {
        this.CLOSE_BUTTONS[i].addEventListener('click', this.closeModal.bind(this))
      }
    }

    // Close on escape
    document.addEventListener('keydown', (e) =>
      (e.key === 'Escape' && this.ELEMENT.classList.contains('mtt-modal--show'))
        ? this.closeModal()
        : ''
    )

    // this will check if CF7 doesn't use ajax, and open the modal after cf7 submission / page refresh
    this.checkForUrlParam() && this.openModal()
  }

  openModal (e) {
    e && e.preventDefault()
    this.ELEMENT.classList.add('mtt-modal--show')
  }

  closeModal () {
    this.ELEMENT.classList.remove('mtt-modal--show')
  }

  checkForUrlParam () {
    const url = window.location.href
    return url.indexOf(this.PARAM) !== -1
  }
}
